var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3541)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21918 7.54351C8.63163 7.93609 7.94086 8.14564 7.23423 8.14564C6.28695 8.14469 5.37874 7.76797 4.70891 7.09814C4.03908 6.42831 3.66235 5.5201 3.66141 4.57282C3.66141 3.86618 3.87095 3.17541 4.26354 2.58787C4.65612 2.00032 5.21412 1.54238 5.86697 1.27197C6.51981 1.00155 7.23819 0.930794 7.93125 1.06865C8.62431 1.20651 9.26092 1.54679 9.76059 2.04646C10.2603 2.54612 10.6005 3.18274 10.7384 3.8758C10.8763 4.56886 10.8055 5.28723 10.5351 5.94008C10.2647 6.59292 9.80672 7.15092 9.21918 7.54351ZM8.55753 2.59236C8.16583 2.33064 7.70532 2.19094 7.23423 2.19094C6.60251 2.19094 5.99667 2.44189 5.54998 2.88858C5.10329 3.33527 4.85235 3.94111 4.85235 4.57282C4.85235 5.04391 4.99204 5.50442 5.25377 5.89612C5.51549 6.28782 5.88749 6.59311 6.32272 6.77339C6.75795 6.95367 7.23687 7.00083 7.69891 6.90893C8.16095 6.81702 8.58536 6.59017 8.91847 6.25706C9.25158 5.92395 9.47843 5.49954 9.57034 5.0375C9.66224 4.57546 9.61507 4.09654 9.43479 3.66131C9.25451 3.22608 8.94922 2.85408 8.55753 2.59236ZM3.44642 10.9084C4.45113 9.90369 5.81335 9.33855 7.23422 9.33697C7.29933 9.33704 7.36432 9.3383 7.42915 9.34073C7.1575 9.52416 6.97888 9.8349 6.97888 10.1873V10.5357C5.96655 10.5978 5.00811 11.0275 4.2868 11.7488C3.5051 12.5305 3.06594 13.5907 3.06594 14.6962C3.06594 14.8541 3.0032 15.0056 2.89153 15.1173C2.77986 15.2289 2.6284 15.2917 2.47047 15.2917C2.31254 15.2917 2.16108 15.2289 2.04941 15.1173C1.93774 15.0056 1.875 14.8541 1.875 14.6962C1.87658 13.2753 2.44171 11.9131 3.44642 10.9084ZM11.9845 15.2915C11.989 15.2916 11.9935 15.2917 11.998 15.2917C12.0025 15.2917 12.007 15.2916 12.0114 15.2915H11.9845Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04306 9.33481L13.3734 13.6652M14.2708 11.5C14.2708 13.1914 12.8996 14.5625 11.2083 14.5625C9.51688 14.5625 8.14575 13.1914 8.14575 11.5C8.14575 9.80863 9.51688 8.4375 11.2083 8.4375C12.8996 8.4375 14.2708 9.80863 14.2708 11.5Z",
    stroke: "currentColor",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockUser);
export default __webpack_public_path__ + "static/media/blockUser.ad3ee2b29326e2d997d736369295b239.svg";
export { ForwardRef as ReactComponent };